/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * テキスト配置 (null許容)
 * @export
 */
export const TextAlignmentNullable = {
    Left: 'left',
    Center: 'center',
    Right: 'right'
};
export function TextAlignmentNullableFromJSON(json) {
    return TextAlignmentNullableFromJSONTyped(json, false);
}
export function TextAlignmentNullableFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function TextAlignmentNullableToJSON(value) {
    return value;
}
